import { render, staticRenderFns } from "./RequestSuccess.vue?vue&type=template&id=b4b653dc&scoped=true"
import script from "./RequestSuccess.vue?vue&type=script&lang=ts"
export * from "./RequestSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b653dc",
  null
  
)

export default component.exports